const t_key = 'COMUN.VALIDATIONS.'
export function required (value, allValues, props) {
  return (!!value && ('' + value).trim().length > 0) ? undefined : props.t(`${t_key}REQUIRED`)
}